<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/template/page"
                   getKey="rows" :columns="columns" >
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('xieyimubanmingcheng')">
            <el-input v-model="yt.conditions.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('xieyimubandaima')">
            <el-input v-model="yt.conditions.code"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary"
                       plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear()">{{ $t('chongzhi') }}
            </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>

      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('mubandianbianji', scope.row,'70%')">
              {{ $t('mubandianbianji') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text"
                       @click="pointShow = !pointShow,templateId = scope.row.id,customerId = $attrs.customerId">
              {{ $t('模板点导入') }}
            </el-button>
          </el-col>
        </el-row>
      </template>
      <!-- 底部插槽 -->
      <!-- <div slot="footer"></div> -->
    </yi_curd_table>

    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
               :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">

      <!-- 模板点编辑弹窗 -->
      <template v-if="yt.editObj.action == 'mubandianbianji'">
        <div class="dialog-scroller">
          <template_point :templateId="yt.editObj.id" :customerId="this.$attrs.customerId"></template_point>
        </div>
      </template>

      <!-- 模板点导入弹窗 -->
      <template v-if="yt.editObj.action == 'mubandiandaoru'">
        <div class="dialog-scroller">
          <point_import_excel></point_import_excel>
        </div>
      </template>
    </el-dialog>
    <point_import_excel :show.sync="pointShow" :templateId="templateId" :customerId="customerId"></point_import_excel>
  </div>
</template>
<script type="text/javascript">
import point_import_excel from '@@/pages/admin/customer/info/protocol/point_import_excel'
import template_point from '@@/pages/admin/customer/info/protocol/template_point'

export default {
  components: {
    point_import_excel,
    template_point,
  },
  name: 'admin_customer_info_protocol_list',

  data() {
    return {
      pointShow: false,
      eventShow: false,
      mainTemplateList: [],
      columns: [{
        label: 'xieyimubanmingcheng',
        prop: 'name',
        width: 250
      }, {
        label: 'xieyimubandaima',
        prop: 'code'
      }, {
        label: 'xieyimubanbeizhu',
        prop: 'remark',
        // width: 130
      }, {
        label: 'caozuo',
        type: 'slot',
        width: 300,
        fixed: 'right'
      }
      ]
    };
  },
  created() {
    setTimeout(() => {
      /*this.yt.conditions = {
        orderBy:'createTime desc',
      }*/
      this.yt.SELECT_URL = "/web/template/getEquipmentTemplateByIds"
      this.yt.SELECT_RESULT_KEY = "data"
      this.yt.SELECT_ID = "id"
      this.yt.SELECT_TITLE = "name"
      this.yt.get(1);
    }, 300)

  },
  computed: {},
  methods: {
    // 获取主协议
    async getTemplateIsMain(rowId) {
      this.mainTemplateList = []
      let response = await this.http.get('/web/template/point/mapping/listMappingWithAllGeneralPoints', {
        params: {
          templateId: rowId,
        }
      })
      this.mainTemplateList = response.data
      // 固定展现排序
      this.mainTemplateList.sort(function (a, b) {
        return a.pointId - b.pointId
      })
    },

    beforeAddMapping(params) {
      params = this.mainTemplateList
      return params
    },
  }
};
</script>
